// extracted by mini-css-extract-plugin
export default {"link":"tE-z","disabled":"uE-z"};